import React, { useState, useRef } from "react";
import classNames from "classnames";
import Gallery from "../Gallery/Gallery";
import "./ProjectCard.scss";

export default function ProjectCard({
  folder,
  name,
  year,
  thumbnail,
  images,
  timestamp,
}) {
  const [showGallery, setShowGallery] = useState(false);
  const [isFirstImageLoaded, setIsFirstImageLoaded] = useState(false);
  const firstImageRef = useRef(null);

  const yearStyle = classNames({
    "project-card-year": year,
    "project-card-year-clear": !year,
  });

  const getImageUrl = (image) => {
    return `images/${folder}/${image}?v=${timestamp}`;
  };

  const getThumbnailUrl = () => {
    return `images/${folder}/thumbnail/${thumbnail}?v=${timestamp}`;
  };

  const galleryItems = images.map((image) => ({
    src: getImageUrl(image),
    alt: `${name} — ${image}`,
  }));

  const handleThumbnailLoad = () => {
    if (!images?.length) {
      return;
    }

    const preloadImage = new Image();
    preloadImage.onload = () => setIsFirstImageLoaded(true);
    preloadImage.src = getImageUrl(images[0]);
  };

  return (
    <div className="project-card-wrapper">
      <div className="project-card-title">{name}</div>
      <div>
        <div className={yearStyle}>{year}</div>
        <img
          src={getThumbnailUrl()}
          onClick={() => setShowGallery(true)}
          onLoad={handleThumbnailLoad}
          className="project-card-image"
          alt={name}
        />

        {isFirstImageLoaded && images?.length > 0 && (
          <div style={{ display: "none" }}>
            <img ref={firstImageRef} src={getImageUrl(images[0])} alt="" />
          </div>
        )}

        <Gallery
          isOpen={showGallery}
          items={galleryItems}
          onClose={() => setShowGallery(false)}
          loop
          keyboard
          swipe
        />
      </div>
    </div>
  );
}
